<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="发货方名称">
            <el-input
              v-model="formData.originPointName"
              placeholder="请输入发货方名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="始发地" prop="originCityCode">
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="formData.originProvinceCode"
              :provinceName.sync="formData.originProvinceName"
              :cityCode.sync="formData.originCityCode"
              :cityName.sync="formData.originCityName"
              :districtCode.sync="formData.originDistrictCode"
              :districtName.sync="formData.originDistrictName"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货方名称">
            <el-input
              v-model="formData.destPointName"
              placeholder="请输入收货方名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="目的地" prop="destinationCityCode">
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="formData.destinationProvinceCode"
              :provinceName.sync="formData.destinationProvinceName"
              :cityCode.sync="formData.destinationCityCode"
              :cityName.sync="formData.destinationCityName"
              :districtCode.sync="formData.destinationDistrictCode"
              :districtName.sync="formData.destinationDistrictName"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item label="时效（小时）" prop="lineTime">
            <el-input-number
              placeholder="不限"
              v-model="formData.lineTime"
              :min="0"
              :controls="false"
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="订单类型" prop="bizType">
            <dict-select
              clearable
              v-model="formData.orderType"
              placeholder="不限"
              default
              filterable
              style="width:100%"
              :body="selectOrderType"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="业务类型" prop="bizType">
            <dict-select
              clearable
              v-model="formData.bizType"
              placeholder="不限"
              default
              filterable
              style="width:100%"
              :body="selectBizType"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="货品类型" prop="goodsType">
            <dict-select
              clearable
              v-model="formData.goodsType"
              placeholder="不限"
              default
              filterable
              style="width:100%"
              :body="selectGoodsType"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="报价方式" prop="linePriceType">
            <el-select v-model="formData.linePriceType">
              <el-option
                v-for="item in linePriceTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="detailPage.chargeUnit !== '1'">
          <el-form-item label="最低收费" prop="lineMinPrice">
            <el-input-number
              v-model="formData.lineMinPrice"
              style="width:100%"
              :min="0"
              :controls="false"
              :precision="2"
              :disabled="detailPage.chargeUnit === '1'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="detailPage.chargeUnit === '1'">
          <el-form-item label="是否返程" prop="isBack">
            <el-select
              v-model="formData.isBack"
              :disabled="detailPage.chargeUnit !== '1'"
            >
              <el-option
                v-for="item in isBackOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="mt-2">
      <line-price-table
        v-if="isVehicle"
        ref="table"
        :tableData="formData.priceList"
      />
      <line-price-cool-table
        v-else-if="isCool"
        ref="table"
        :tableData="formData.priceList"
      />

      <line-price-tiered-table
        v-else
        ref="table"
        :lineMinPrice="formData.lineMinPrice"
        :tableData="formData.tieredPriceList"
      />
    </div>
  </div>
</template>
<script>
import LinePriceTable from '../line-price-table'
import LinePriceTieredTable from '../line-price-tiered-table'
import LinePriceCoolTable from '../line-price-cool-table'

import validate from '@/libs/util.validate'
export default {
  components: {
    LinePriceTable,
    LinePriceTieredTable,
    LinePriceCoolTable,
  },
  inject: {
    detailPage: {
      default: {},
    },
  },
  props: {
    contractCarrierCode: String,
    contractCarrierLineCode: String,
  },
  data() {
    var checkOrigin = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择始发地，并至少精准到城市！'))
      } else {
        callback()
      }
    }
    var checkDestination = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择目的地，并至少精准到城市！'))
      } else {
        callback()
      }
    }
    return {
      regionShow: false,
      loaded: false,
      selectOrderType: { type: 'orderType' },
      selectBizType: { type: 'bizType' },
      selectGoodsType: { type: 'goodsType' },
      formData: {
        contractCarrierCode: this.contractCarrierCode,
        isBack: 0,
        priceList: [],
        tieredPriceList: [],
      },
      rules: {
        linePriceType: [
          { required: true, message: '请选择报价方式', trigger: 'change' },
        ],
        originCityCode: [
          { required: true, validator: checkOrigin, trigger: 'change' },
        ],
        destinationCityCode: [
          { required: true, validator: checkDestination, trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    // 计费单位是否为车
    isVehicle() {
      return this.detailPage.chargeUnit == '1'
    },
    // 计费单位是否为冷藏箱
    isCool() {
      return this.detailPage.chargeUnit == '11'
    },
    linePriceTypeOptions() {
      let options = [
        {
          value: 'D',
          label: '阶梯报价（单价）',
        },
        {
          value: 'B',
          label: '阶梯报价（运价）',
        },
        {
          value: 'C',
          label: '累进报价（单价）',
        },
        {
          value: 'E',
          label: '进阶报价',
        },
      ]
      if (
        this.detailPage.chargeUnit == '1' ||
        this.detailPage.chargeUnit == '11'
      ) {
        options = [
          {
            value: 'A',
            label: '整车报价',
          },
        ]
      }
      return options
    },
    isBackOptions() {
      let options = [
        {
          value: 0,
          label: '否',
        },
        {
          value: 1,
          label: '是',
        },
      ]
      return options
    },
  },
  watch: {
    contractCarrierLineCode: {
      handler(contractCarrierLineCode) {
        if (contractCarrierLineCode || contractCarrierLineCode !== '') {
          this.loadDetail()
        } else {
          this.regionShow = true
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadDetail() {
      this.$api
        .contractCarrierLineDetailApi({
          contractCarrierLineCode: this.contractCarrierLineCode,
        })
        .then((res) => {
          this.formData = res.body
          this.regionShow = true
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return Promise.reject()

      const tableData = await this.$refs.table.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.warning('请添加价格信息')
        return Promise.reject()
      }

      const validResult = await this.$refs.table.validEvent()
      if (!validResult) return Promise.reject()

      this.isVehicle
        ? (this.formData.priceList = tableData)
        : (this.formData.tieredPriceList = tableData)

      this.isCool
        ? (this.formData.priceList = tableData)
        : (this.formData.tieredPriceList = tableData)

      if (this.isCool) {
        this.formData.priceList.forEach((e) => {
          e.vehicleModel = e.boxType
          e.vehicleModelText = e.boxTypeText
        })
      } else {
        for (let i = 0; i < tableData.length - 1; i++) {
          for (let j = 0; j < tableData.length - 1 - i; j++) {
            if (tableData[j].vehicleModel) {
              if (
                tableData[j].vehicleModel === tableData[j + 1].vehicleModel &&
                tableData[j].vehicleLength === tableData[j + 1].vehicleLength
              ) {
                this.$message.warning(
                  '有车辆类型和车长都相同的价格信息，请检查'
                )
                return Promise.reject()
              }
            }
          }
        }
      }

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      return this.$api
        .contractCarrierLineSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          const { status, msg } = res
          this.$message({
            type: status === 200 ? 'success' : 'error',
            message: msg,
          })
          return res
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
